import { render, staticRenderFns } from "./mallGoodsReflection.vue?vue&type=template&id=62525ba3&"
import script from "./mallGoodsReflection.vue?vue&type=script&lang=js&"
export * from "./mallGoodsReflection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62525ba3')) {
      api.createRecord('62525ba3', component.options)
    } else {
      api.reload('62525ba3', component.options)
    }
    module.hot.accept("./mallGoodsReflection.vue?vue&type=template&id=62525ba3&", function () {
      api.rerender('62525ba3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reflection/mallGoodsReflection.vue"
export default component.exports